import React from 'react'
import Carousal from '../component/Carousal'
import Aboutsection from './Aboutsection'
import Treatment from './Treatment'
import Footer from './Footer'
import TreatmentSlider from './TreatmentSlider'

const Home = () => {
  return (
    <div className='main'>
      <Carousal />
      <Aboutsection />
      <Treatment />
      <TreatmentSlider/>
      <Footer />

      
    </div>
  )
}

export default Home
